// test1054
(1054 && 0);
